import React, { useEffect, useRef, useState } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import Loading from '../Loading/Loading';
import { BiMessageError, BiMessageCheck } from 'react-icons/bi';

function Contact() {
  const [loading, setLoading] = useState(false);
  const [emailSucess, setEmailSucess] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [formInput, setFormInput] = useState({ name: '', email: '', message: '' })

  const form = useRef();

  const inputHandler = ({ target : { name, value} }) => setFormInput({...formInput, [name]: value});

  useEffect(() => {
    const validator = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    const validInput = formInput.name && formInput.email && formInput.message
      && formInput.name.length > 2
      && (validator.test(formInput.email))
      && formInput.message.length > 0;
   
    setIsDisabled(!validInput);
  }, [formInput]);

  const onClickSendButton = async (event) => {
    event.preventDefault();
    setLoading(true);
    setIsDisabled(true);
    setEmailSucess(null);

    try{
      const { status } = await emailjs.sendForm(
        'service_flk2f3r',
        'template_0tex6u5',
        form.current,
        'iuyPJ-prDJSo-34Z0',
      );

      if (status === 200) {
        setLoading(false);
        setEmailSucess(true);
        setIsDisabled(false);
        setFormInput({ name: '', email: '', message: '' });
      }
    } catch (error) {
      setLoading(false);
      setEmailSucess(false);
      setIsDisabled(false);
      console.log(error);
    }
  }

  return (
    <section id="contact">
      <h3>Entre em</h3>
      <h2>Contato</h2>

      <div className="contact-container">
        <form className="message-form" ref={ form }>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Seu nome"
            className="input"
            required
            onChange={ inputHandler }
            value={ formInput.name }
          />

          <input
            type="email"
            name="email"
            id="email"
            placeholder="Seu email"
            className="input"
            required
            onChange={ inputHandler }
            value={ formInput.email }
          />

          <textarea
            name="message"
            id="message"
            placeholder="Sua mensagem"
            className="textarea-message input"
            required
            onChange={ inputHandler }
            value={ formInput.message }
          />

          <button
            type="submit"
            className="form-btn"
            onClick={ onClickSendButton }
            disabled={ isDisabled }
          >
            { loading ? <Loading /> : 'Enviar'}
          </button>
        </form>
        <div className="form-message">
        
          { emailSucess && <span><BiMessageCheck className="form-icon"/> Mensagem enviada com sucesso.</span> }
          { emailSucess === false && <span><BiMessageError className="form-icon" /> Ocorreu um erro, por favor tente novamente.</span> }
          
        </div>
      </div>
    </section>
  )
}

export default Contact;
